import * as React from 'react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { FaTrashAlt, FaFileExport, FaAngleDoubleRight, FaEye, FaVoteYea } from 'react-icons/fa'
import { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';

export default function TreatmentDeferDialog(props) {
    const token = localStorage.getItem('token')
    const url = process.env.REACT_APP_APP_URL
    const api = axios.create({
        baseURL: url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    })

    const [defferAmount, setDefferAmount] = useState('')
    // console.log(props.data.medicineItems[0].item_id, 'props')
    const [date, setDate] = useState('')
    const [all, setAll] = useState([])
    const [firstAccount, setFirstAccount] = useState([])
    const [secAccount, setSecAccount] = useState([])
    const [relatedPatient, setRelatedPatient] = useState([])

    const allItems = props.data && [...all, ...props.data?.medicineItems]
    console.log(props.data?.medicineItems, 'all')


    //setting up for data
    // setAll([...all, props.data?.medicineItems])
    // console.log(allItems, 'sfsdjfaskl')
    useEffect(() => {
        // const list = [...allItems]

        const getAccountingLists = async () => {
            const res = await api.get('accounting-lists')
            const FirAcc = res.data.list.filter(
                e => e.name == 'Deferred Treatment Sale'
            )
            setFirstAccount(FirAcc)
            const SecAcc = res.data.list.filter(e => e.name === 'Treatment Sale')
            setSecAccount(SecAcc)
        }

        const getPatientTreatment = async () => {
            const res = await api.get('patient-treatments')

            setRelatedPatient(res.data.list)
        }

        // getBankLists();

        getAccountingLists()
        getPatientTreatment()
    }, [])

    const _export1 = React.useRef(null)
    const exportBtnHandler = () => {
        if (_export1.current !== null) {

            _export1.current.props.data.filter(el => el.item_id.medicineItemName).map(function (element, index) {
                // element.code = element.item_id.code
                element.mcode = element.item_id.code
                element.mname = element.item_id.medicineItemName
                element.mqty = element.qty

            })
            _export1.current.props.data.filter(el => el.item_id.procedureItemName).map(function (element, index) {
                // element.code = element.item_id.code
                element.pcode = element.item_id.code
                element.pname = element.item_id.procedureItemName
                element.pqty = element.qty

            })
            _export1.current.props.data.filter(el => el.item_id.accessoryItemName).map(function (element, index) {
                // element.code = element.item_id.code
                element.acode = element.item_id.code
                element.aname = element.item_id.accessoryItemName
                element.aqty = element.qty

            })
            _export1.current.props.data.filter(el => el.item_id.generalItemName).map(function (element, index) {
                // element.code = element.item_id.code
                element.gcode = element.item_id.code
                element.gname = element.item_id.generalItemName
                element.gqty = element.qty

            })

            _export1.current.save()
        }
    }
    return (
        <div>
            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='lg'>
                <DialogTitle>
                    {' '}
                    <div className='modal-header bg-info'>
                        <h2 className='modal-title'>Detail</h2>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={props.close}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {/* Medicine */}
                        {props.data && props.data.medicineItems[0] && (
                            <div>
                                <h5 className='text-decoration-underline'>Items</h5>
                                <div>
                                    <table className='table table-borderless'>
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Code</th>
                                                <th>Item Name</th>
                                                <th>Transfer Qty</th>
                                                <th>Unit Name</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: '16px', fontWeight: '10px' }}>
                                            {props.data && props.data.medicineItems.map((item, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.item_id.code}</td>
                                                    <td>{item?.item_id.medicineItemName}</td>

                                                    <td>{item.qty}</td>
                                                    <td>{item?.relatedItemUnit?.unitName}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}




                        {/* Pro Med */}
                        {props.data && props.data.procedureItems[0] && (
                            <div>
                                <h5 className='text-decoration-underline'>Procedure Medicine</h5>
                                <div>
                                    <table className='table table-borderless'>
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Code</th>
                                                <th>Item Name</th>
                                                <th>Transfer Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: '16px', fontWeight: '10px' }}>
                                            {props.data && props.data.procedureItems.map((item, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.item_id.code}</td>
                                                    <td>{item?.item_id.procedureItemName}</td>

                                                    <td>{item.qty}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}



                        {/* Pro Ass */}
                        {props.data && props.data.accessoryItems[0] && (
                            <div>
                                <h5 className='text-decoration-underline'>Procedure Accessory</h5>
                                <div>
                                    <table className='table table-borderless'>
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Code</th>
                                                <th>Item Name</th>
                                                <th>Transfer Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: '16px', fontWeight: '10px' }}>
                                            {props.data && props.data.accessoryItems.map((item, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.item_id.code}</td>
                                                    <td>{item?.item_id.accessoryItemName}</td>

                                                    <td>{item.qty}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}




                        {/* General */}
                        {props.data && props.data.generalItems[0] && (
                            <div>
                                <h5 className='text-decoration-underline'>General</h5>
                                <div>
                                    <table className='table table-borderless'>
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Code</th>
                                                <th>Item Name</th>
                                                <th>Transfer Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody style={{ fontSize: '16px', fontWeight: '10px' }}>
                                            {props.data && props.data.generalItems.map((item, index) => (
                                                <tr>
                                                    <td>{index + 1}</td>
                                                    <td>{item?.item_id.code}</td>
                                                    <td>{item?.item_id.generalItemName}</td>

                                                    <td>{item.qty}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}
                        <div className='text-center py-3'>
                            <button onClick={exportBtnHandler} className='btn btn-sm btn-success '>Export to Excel</button>
                            <ExcelExport data={allItems} ref={_export1} fileName={`${props.data.code}-${props.data.createdAt?.split('T')[0]}`}>
                                <ExcelExportColumn
                                    field=''
                                    title='No'
                                    locked={true}
                                    width={30}
                                />


                                {/* <ExcelExportColumn
                                    field='mcode'
                                    title='Code'
                                    headerCellOptions={{
                                        textAlign: 'center'
                                    }}
                                    width={250}
                                /> */}

                                <ExcelExportColumn
                                    // field='item_id.medicineItemName'

                                    title='Medicine'

                                    headerCellOptions={{
                                        textAlign: 'center',
                                        fontSize: 20,


                                    }}
                                    width={250}
                                    height={60}
                                >
                                    <ExcelExportColumn
                                        field='mcode'
                                        title='Code'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>

                                    <ExcelExportColumn
                                        field='mname'
                                        title='Medicine Item Name'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                    <ExcelExportColumn
                                        field='mqty'
                                        title='Quantity'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        cellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                </ExcelExportColumn>




                                <ExcelExportColumn
                                    // field='item_id.medicineItemName'
                                    title='Procedure'
                                    headerCellOptions={{
                                        textAlign: 'center',
                                        fontSize: 20,

                                    }}
                                    width={250}
                                >

                                    <ExcelExportColumn
                                        field='pcode'
                                        title='Code'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>

                                    <ExcelExportColumn
                                        field='pname'
                                        title='Procedure Item Name'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                    <ExcelExportColumn
                                        field='pqty'
                                        title='Quantity'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        cellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                </ExcelExportColumn>

                                <ExcelExportColumn
                                    // field='item_id.medicineItemName'
                                    title='Accessory List'
                                    headerCellOptions={{
                                        textAlign: 'center',
                                        fontSize: 20,

                                    }}
                                    width={250}
                                >

                                    <ExcelExportColumn
                                        field='acode'
                                        title='Code'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>

                                    <ExcelExportColumn
                                        field='aname'
                                        title='Accessory Item Name'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={350}
                                    >

                                    </ExcelExportColumn>
                                    <ExcelExportColumn
                                        field='aqty'
                                        title='Quantity'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        cellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                </ExcelExportColumn>

                                <ExcelExportColumn
                                    // field='item_id.medicineItemName'
                                    title='General List'
                                    headerCellOptions={{
                                        textAlign: 'center',
                                        fontSize: 20,

                                    }}
                                    width={250}
                                >

                                    <ExcelExportColumn
                                        field='gcode'
                                        title='Code'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>

                                    <ExcelExportColumn
                                        field='gname'
                                        title='General Item Name'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }}

                                        width={350}
                                    >

                                    </ExcelExportColumn>
                                    <ExcelExportColumn
                                        field='gqty'
                                        title='Quantity'
                                        headerCellOptions={{
                                            textAlign: 'center'
                                        }} cellOptions={{
                                            textAlign: 'center'
                                        }}
                                        width={250}
                                    >

                                    </ExcelExportColumn>
                                </ExcelExportColumn>



                            </ExcelExport>

                        </div>

                    </DialogContentText>




                </DialogContent>
            </Dialog>
        </div>
    )
}
